import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../../transactions/pages/list/models/params.model';
import { TranslateService } from '@ngx-translate/core';
import * as actions from '../../json/actions.json';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
@Component({
  selector: 'app-flow-action-zero-auth',
  templateUrl: './flow-action-zero-auth.component.html',
  styleUrls: ['./flow-action-zero-auth.component.scss']
})
export class FlowActionZeroAuthComponent implements OnInit {

  model: any = {};
  params: Params;

  @Input() expandedStepState: boolean;
  @Input() flow_order: any;
  @Input() flow: any;
  @Input() operations: any;
  @Input() onlyViewer;
  @Input() form;
  @Input() terms: any;

  actions: any = (actions as any).default.actions;

  @ViewChild('flow_order_name') flowOrderNameElement: ElementRef;
  @ViewChild('editInput') editInputElement: ElementRef;
  @Output() changeInput = new EventEmitter<any>();

  constructor(private route: ActivatedRoute, private userService: UserService,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.model.user = this.userService.user;

    this.operations?.forEach(element => {
      element.operators.filter((c, index) => {
        return element.operators.indexOf(c) === index;
      });
    });
    this.route.paramMap.subscribe((params) => {
      this.params = new Params(params);
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });

    this.actions = this.actions.filter(p => p.flow_type_id.some(x => x == this.flow.flow.flow_type_id));
    this.createFlowOrder();
  }

  editStep(event: any) {
    this.changeInput.emit({ key: this.flow_order.key, name: this.flow_order.name });
    event.stopPropagation();
  }

  createFlowOrder() {
    this.flow_order.actions.forEach((action) => {
      this.createAction(action);
    });
  }

  blurEventOption(event, expression) {
    expression.binary_expr.left.var_expr.var_name = event.target.value;
  }
  blurEventOperatorsAction(event, expression) {
    expression.binary_expr.symbol = event.target.value;
  }
  blurEventValues(event, expression) {
    expression.binary_expr.right.const_expr.const = event.target.value;
  }

  createCtrlOptions(expression) {
    var ctrl: AbstractControl = null;
    let val: any[] = [];
    ctrl = new FormControl(null, val);
    ctrl.setValidators([this.validatorTerms(expression), Validators.required]);
    return ctrl;
  }

  createCtrlOperators(type) {
    var ctrl: AbstractControl = null;
    let val: any[] = [];
    ctrl = new FormControl(null, val);
    if (type)
      ctrl.setValidators([this.validatorOperators(type), Validators.required]);
    else
      ctrl.setValidators([this.validatorOperators(null), Validators.required]);
    return ctrl;
  }

  createCtrlValues(expression, name) {
    var ctrl: AbstractControl = null;
    let val: any[] = [];
    ctrl = new FormControl(null, val);

    if (name)
      ctrl.setValidators([this.validatorValues(expression, name), Validators.required]);
    else
      ctrl.setValidators([this.validatorValues(expression, null), Validators.required]);

    return ctrl;
  }

  createCtrlActions(action) {
    var ctrl: AbstractControl = null;
    let val: any[] = [];
    ctrl = new FormControl(null, val);
    ctrl.setValidators([this.validatorActions(action), Validators.required]);
    return ctrl;
  }

  validatorTerms(expression): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = expression.binary_expr.variables.findIndex(name => {
        if (control.value)
          return (new RegExp('\^' + name.name + '\$')).test(control.value);
        return true;
      });
      return index < 0 ? { 'options': { value: control.value } } : null;
    };
  }

  validatorOperators(type): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (type) {
        const index = this.operations?.find(p => p.type == type).operators.findIndex(operator => {
          if (control.value)
            return (new RegExp('\^' + operator + '\$')).test(control.value);
          return true;
        });
        return index < 0 ? { 'operators': { value: control.value } } : null;
      } else {
        const index = this.operations?.map(p => p.operators).findIndex(operator => {
          if (control.value)
            return (new RegExp('\^' + operator + '\$')).test(control.value);
          return true;
        });
        return index < 0 ? { 'operators': { value: control.value } } : null;
      }

    };
  }

  validatorValues(expression, name): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } | null => {
      if (name) {
        if (name) {
          if (expression.binary_expr.variables.find(p => p.name == name)) {
            if (expression.binary_expr.variables.find(p => p.name == name).type == 'list') {
              const index = expression.binary_expr.variables.find(p => p.name == name).values.findIndex(operator => {
                if (control.value)
                  return (new RegExp('\^' + operator + '\$')).test(control.value);
                return true;
              });
              return index < 0 ? { 'values': { value: control.value } } : null;
            }
            return null;
          }

          return null;
        }
      }
      return null;
    };
  }

  validatorActions(action): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = action.action.actions.findIndex(operator => {
        if (control.value)
          return (new RegExp('\^' + operator.description + '\$')).test(control.value);
        return true;
      });
      return index < 0 ? { 'actions': { value: control.value } } : null;
    };
  }

  selectAction(action, value) {

    action.action.typeDescription = this.actions.find(p => p.id == value).description;
    action.action.type = this.actions.find(p => p.id == value).id;

    this.form.get('actions' + action.id).setValue(action.action.typeDescription);

  }

  selectedOption(expression, value, action) {

    var optionModel = expression.binary_expr.variables.find(p => p.name == value);
    if (optionModel) {
      var operatorsPossiblesByOption = this.operations?.find(p => p.type == optionModel.type).operators;
      expression.binary_expr.operators = operatorsPossiblesByOption;
      expression.binary_expr.operators_filtered = operatorsPossiblesByOption;
    }
    else {
      expression.binary_expr.operators = [];
    }
    expression.binary_expr.values = optionModel ? optionModel.values : [];
    expression.binary_expr.values_filtered = optionModel ? optionModel.values : [];

    if (!this.onlyViewer && !this.flow.is_default) {
      this.form.get('operators' + expression.binary_expr.id).enable();
      this.form.get('values' + expression.binary_expr.id).enable();
      this.form.get('actions' + action.id).enable();
    }

    this.form.get('operators' + expression.binary_expr.id).setValidators(optionModel ? [this.validatorOperators(optionModel.type), Validators.required] : [])
    this.form.get('operators' + expression.binary_expr.id).updateValueAndValidity();

    this.form.get('actions' + action.id).setValidators([this.validatorActions(action), Validators.required]);
    this.form.get('actions' + action.id).updateValueAndValidity();

    if (optionModel)
      if (optionModel.type == 'list') {
        this.form.get('values' + expression.binary_expr.id).setValidators(optionModel ? [this.validatorValues(expression, optionModel.name), Validators.required] : [])
        this.form.get('values' + expression.binary_expr.id).updateValueAndValidity();
      } else {
        this.form.get('values' + expression.binary_expr.id).setValidators([Validators.required])
        this.form.get('values' + expression.binary_expr.id).updateValueAndValidity();
      }

  }

  createExpressionActions(option, operator, value) {

    var values = [value];
    let variablesMoreTerms = this.terms;

    var obj = {
      id: '_' + Math.random().toString(36).substr(2, 9),
      variables: variablesMoreTerms,
      variables_filtered: variablesMoreTerms,
      operators: [],
      operators_filtered: [],
      values: values,
      values_filtered: values,
      disabled: false
    };
    return obj;
  }

  createAction(action) {

    action.id = '_' + Math.random().toString(36).substr(2, 9);
    action.action.actions = this.actions;
    action.action.actions_filtered = this.actions;

    action.action.typeDescription = this.actions.find(p => p.id == action.action.type.toLowerCase()) ? this.actions.find(p => p.id == action.action.type.toLowerCase()).description : this.flow_order.type.toLowerCase();
    action.action.type = this.actions.find(p => p.id == action.action.type.toLowerCase()) ? this.actions.find(p => p.id == action.action.type.toLowerCase()).id : this.flow_order.type.toLowerCase();

    this.form.addControl('actions' + action.id, this.createCtrlActions(action));

    if (action.action.typeDescription)
      this.form.get('actions' + action.id).setValue(action.action.typeDescription);

    if (action.filters) {
      if (action.filters.expression) {
        if (action.filters.expression.nary_expr?.expression_list) {

          action.filters.expression.nary_expr?.expression_list.forEach(expression => {
            this.createExpression(expression, action);
          });
        }
      }
    }
  }


  createExpression(expression, action) {

    var filters =
      this.createExpressionActions(
        expression.binary_expr.left.var_expr.var_name,
        expression.binary_expr.symbol,
        expression.binary_expr.right.const_expr.const
      );


    expression.binary_expr.id = filters.id;
    expression.binary_expr.variables = filters.variables;
    expression.binary_expr.operators = filters.operators;
    expression.binary_expr.values = filters.values;
    expression.binary_expr.variables_filtered = filters.variables;
    expression.binary_expr.operators_filtered = filters.operators;
    expression.binary_expr.values_filtered = filters.values;

    expression.binary_expr.left.var_expr.tuna_type = null;

    var optionModel = filters.variables.find(p => p.name == (expression.binary_expr.left.var_expr.var_name ? expression.binary_expr.left.var_expr.var_name : ''));

    this.form.addControl('options' + filters.id, this.createCtrlOptions(expression));
    if (optionModel) {
      this.form.addControl('operators' + filters.id, this.createCtrlOperators(optionModel.type));
    } else {
      this.form.addControl('operators' + filters.id, this.createCtrlOperators(null));
    }

    if (optionModel) {
      this.form.addControl('values' + filters.id, this.createCtrlValues(expression, optionModel.name));
    } else {
      this.form.addControl('values' + filters.id, this.createCtrlValues(expression, null));
    }

    this.form.get('options' + filters.id).setValue(expression.binary_expr.left.var_expr.var_name ? expression.binary_expr.left.var_expr.var_name : '');
    this.form.get('operators' + filters.id).setValue(expression.binary_expr.symbol ? expression.binary_expr.symbol : '');
    this.form.get('values' + filters.id).setValue(expression.binary_expr.right.const_expr.const ? expression.binary_expr.right.const_expr.const : '');

    if (!expression.binary_expr.left.var_expr.var_name) {
      if (this.onlyViewer || this.flow_order.disabled) {
        this.form.get('options' + filters.id).disable();
        this.form.get('operators' + filters.id).disable();
        this.form.get('values' + filters.id).disable();
        this.form.get('actions' + action.id).disable();
      }
    }

    if (this.onlyViewer) {
      this.form.get('options' + filters.id).disable();
      this.form.get('operators' + filters.id).disable();
      this.form.get('values' + filters.id).disable();
      this.form.get('actions' + action.id).disable();
    }

    this.form.get('options' + filters.id).updateValueAndValidity();
    this.form.get('operators' + filters.id).updateValueAndValidity();
    this.form.get('values' + filters.id).updateValueAndValidity();

    if (expression.binary_expr.left.var_expr.var_name)
      this.selectedOption(expression, expression.binary_expr.left.var_expr.var_name, action);

  }


  valuechangeOption(expression, value, $event) {
    let filteredOptions: Observable<any>;
    const filterValue = value ? value.toLowerCase() : '';
    if (expression.binary_expr.variables) {
      filteredOptions = expression.binary_expr.variables.filter(option => option.name.toLowerCase().includes(filterValue));
      expression.binary_expr.variables_filtered = filteredOptions;

      expression.binary_expr.left.var_expr.tuna_type = null;
    }

  }

  valuechangeOperators(expression, value, $event) {
    let filteredOptions: Observable<any>;
    const filterValue = value ? value.toLowerCase() : '';
    if (expression.binary_expr.operators) {
      filteredOptions = expression.binary_expr.operators.filter(option => option.toLowerCase().includes(filterValue));
      expression.binary_expr.operators_filtered = filteredOptions;
    }

  }

  valuechangeValues(expression, value, $event) {
    let filteredOptions: Observable<any>;
    const filterValue = value ? value.toLowerCase() : '';
    if (expression.binary_expr.values)
      if (expression.binary_expr.values.length > 0) {
        filteredOptions = expression.binary_expr.values.filter(option => option.toLowerCase().includes(filterValue));
        expression.binary_expr.values_filtered = filteredOptions;
      }

  }

  valuechangeAction(action, value) {
    let filteredOptions: Observable<any>;
    const filterValue = value ? value.toLowerCase() : '';
    if (action.action.actions) {
      filteredOptions = action.action.actions.filter(option => option.description.toLowerCase().includes(filterValue));
      action.action.actions_filtered = filteredOptions;
    }

  }


  handleClick(event: MouseEvent): void {
    alert('clicked!');
  }

  clickEditName() {
    if (!this.flow_order.name) {
      this.flow_order.name = this.translateService.instant('flows.detail.custom_action_title');
    }
    setTimeout(() => {
      this.editInputElement.nativeElement.select();
    }, 100);
  }

  inputNameKeyupEnter(event) {
    this.editStep(event);
    this.flowOrderNameElement.nativeElement.hidden = false;
  }
}
